var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavIconToggle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 75,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 38,
    width: 99,
    height: 75
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-34 -38)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.4999 50.6487C36.4999 45.0438 41.0436 40.5001 46.6485 40.5001L120.352 40.5001C125.956 40.5001 130.5 45.0438 130.5 50.6487L130.5 100.351C130.5 105.956 125.956 110.5 120.352 110.5L46.6485 110.5C41.0436 110.5 36.4999 105.956 36.4999 100.351Z",
    stroke: "#A5A5A5",
    strokeWidth: 4.58333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4998 40.5001 66.5002 110.106",
    stroke: "#A5A5A5",
    strokeWidth: 4.58333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5001 56.4999 60.8822 56.5002",
    stroke: "#A5A5A5",
    strokeWidth: 4.58333,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5001 69.4999 60.8822 69.5003",
    stroke: "#A5A5A5",
    strokeWidth: 4.58333,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5001 82.5 60.8822 82.5004",
    stroke: "#A5A5A5",
    strokeWidth: 4.58333,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5001 95.5001 60.8822 95.5004",
    stroke: "#A5A5A5",
    strokeWidth: 4.58333,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIconToggle);
export default __webpack_public_path__ + "static/media/nav-icon-toggle.fd4b3f8bc964493ad44b6f8c06a55dcf.svg";
export { ForwardRef as ReactComponent };